module.exports = __webpack_public_path__ + "img/20190725161615565.31492ac4.png";